// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CancelEmployeeAdvanceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_CancelEmployeeAdvanceResponseDados {
id: number
status: number
status_label: string
}

export type Payroll_CancelEmployeeAdvanceResponse = ApiResponse<Payroll_CancelEmployeeAdvanceResponseDados>;

registerResponseContract('Payroll_CancelEmployeeAdvanceResponse', {
  id:           { type: 'number',  required: true },
  status:       { type: 'number',  required: true },
  status_label: { type: 'string',  required: true },
})
